const APPLICATION_LINK = (process.env.NEXT_PUBLIC_SITE_URL || process.env.NEXT_PUBLIC_BASE_URL || '') as string;

export default APPLICATION_LINK;
